import k from '../k'
import { GameObj } from 'kaplay'
import { stats } from '../state/globals'

export default (partDisplay: GameObj, x: number, y: number) => {
  const part = k.add([k.sprite('part'), k.pos(k.vec2(x, y)), k.area(), 'part'])

  part.onCollide('robot', () => {
    part.destroy()
    stats.parts++
    partDisplay.text = stats.parts.toString()
  })
}
